export async function sendUTXOTransaction(client, { hex, maxFeeRate }) {
    const params = [hex];
    if (maxFeeRate) {
        params.push(maxFeeRate);
    }
    const data = await client.request({
        method: 'sendrawtransaction',
        params: params,
    });
    return data;
}
//# sourceMappingURL=sendUTXOTransaction.js.map